// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4-4sH","logo":"styles_logo__GeQeQ"};